// The business accounts setup wizard's step routes, read by the step configs, the V1 step list and
// the gate-flip redirects in both wizards.
//
// No imports, deliberately: AccountingSetup.tsx reads STATEMENTS_INTRO_PATH for its redirect, and a
// leaf module lets it do that without pulling the Banking component tree in behind it.
const BIZ_ACCOUNT_SETUP_BASE = '/onboarding/biz-account-setup';

export const BANKING_OVERVIEW_PATH = BIZ_ACCOUNT_SETUP_BASE;
export const RELAY_BENEFITS_PATH = `${BIZ_ACCOUNT_SETUP_BASE}/relay-benefits`;
export const RELAY_PITCH_PATH = `${BIZ_ACCOUNT_SETUP_BASE}/relay-pitch`;
export const CONNECT_ACCOUNT_PATH = `${BIZ_ACCOUNT_SETUP_BASE}/connect-account`;
export const CLASSIFY_ACCOUNTS_PATH = `${BIZ_ACCOUNT_SETUP_BASE}/classify-accounts`;

// Registered only when FeatureGates.AccountingSetupRedesignV1 is on. Replaces the accounting
// wizard's /onboarding/accounting-setup/connect-statements, which redirects here under the gate.
export const SYNC_STATEMENTS_PATH = `${BIZ_ACCOUNT_SETUP_BASE}/sync-statements`;

// The hand-off into sync-statements, registered with it and only with it.
export const STATEMENTS_INTRO_PATH = `${BIZ_ACCOUNT_SETUP_BASE}/statements-intro`;

// Manual statement upload, for whatever Auto Statements does not cover. Registered on its own status,
// so it can be walked without sync-statements.
export const UPLOAD_STATEMENTS_PATH = `${BIZ_ACCOUNT_SETUP_BASE}/upload-statements`;

// The accounting setup overview, where both setup flows hand members back to.
export const ACCOUNTING_SETUP_PROGRESS_PATH = '/onboarding/accounting-setup-progress';
